<template>
  <div class="map-container">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import style from '../style.json'
export default {
  name: 'mapboxMap',
  props: {
    defaultOptions: {
      type: Object,
      default: () => ({
        container: 'map',
        style,
        zoom: 2.31,
        center: [-93.68, 60.9],
        attributionControl: false,
        hash: false,
        maxZoom: 17
      })
    },
    geoJSON: {},
    filter: null
  },
  data () {
    return {
      clickedStateId: null
    }
  },
  created () {
    this.map = null
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoiaXN1bWEiLCJhIjoiY2pwNDhxaHVxMHFhbjN3bnI4YWN0cnA5cyJ9.W1zk7c-FzPZqJKaB2QdlFA'
    this.map = new mapboxgl.Map(this.defaultOptions)
    this.map.on('load', () => {
      this.map.addLayer(
        {
          id: 'stamen-watercolor',
          type: 'raster',
          source: {
            type: 'raster',
            tiles: [
              'https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg'
            ],
            tileSize: 256
          },
          minzoom: 0,
          maxzoom: 22,
          paint: {
            'raster-opacity': 1
          }
        }
      )
      this.map.addSource('cities', {
        type: 'geojson',
        data: this.geoJSON,
        promoteId: 'location'
      })
      this.map.addLayer({
        id: 'city-layer',
        type: 'circle',
        source: 'cities',
        paint: {
          'circle-radius': [
            '*',
            ['^', ['length', ['get', 'items']], 0.2],
            5
          ],
          'circle-color': [
            'case',
            ['boolean', ['feature-state', 'click'], false],
            'grey',
            'black'
          ]
        }
      })
      this.map.addLayer({
        id: 'city-layer-text',
        type: 'symbol',
        source: 'cities',
        layout: {
          'text-field': ['get', 'location'],
          'text-variable-anchor': ['top'],
          'text-radial-offset': 0.5,
          'text-justify': 'auto',
          'text-font': ['Amatic SC Bold']
        }
      })
    })

    this.map.on('click', e => {
      const features = this.map.queryRenderedFeatures(e.point, {
        layers: ['city-layer', 'city-layer-text']
      })

      if (features.length > 0) {
        const feature = features[0]
        this.$emit('clickedCity', feature.id)
        this.selectCity(feature.id)
      } else {
        this.$emit('clickedCity', null)
        this.unselectCity()
      }
    })
    this.map.on('mouseenter', 'city-layer', e => {
      this.map.getCanvas().style.cursor = 'pointer'
    })
    this.map.on('mouseleave', 'city-layer', () => {
      this.map.getCanvas().style.cursor = ''
    })
    this.map.on('mouseenter', 'city-layer-text', e => {
      this.map.getCanvas().style.cursor = 'pointer'
    })
    this.map.on('mouseleave', 'city-layer-text', () => {
      this.map.getCanvas().style.cursor = ''
    })
  },
  methods: {
    selectCity (id) {
      this.unselectCity()
      this.clickedStateId = id
      this.map.setFeatureState(
        { source: 'cities', id: this.clickedStateId },
        { click: true }
      )
    },
    unselectCity () {
      if (this.clickedStateId) {
        this.map.setFeatureState(
          { source: 'cities', id: this.clickedStateId },
          { click: false }
        )
        this.clickedStateId = null
      }
    }
  },
  watch: {
    filter (newFilter) {
      this.map.setFilter('city-layer', newFilter)
      this.map.setFilter('city-layer-text', newFilter)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  position: relative;
  height: 100vh;
  width: 100%;
  #map {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
}
</style>
